import axios from "axios";

const LeaveAdjustmentService = {
  async getByEmployee(serviceNo) {
    try {
        const url = `/LeaveAdj/GetLeaveAdj?p_empServiceNo=${encodeURIComponent(serviceNo)}`;
        const response = await axios.get(url);
        console.log("[LeaveAdj] getByEmployee response:", response.data);
        return response.data;
    } catch (error) {
        console.error("[LeaveAdj] Error fetching adjustments:", error);
        throw error;
      }
  },

  async add({ serviceNo, leaveType, date, days, adjustmentType, reason, createdBy }) {
    try {
      const q = (v) => encodeURIComponent(v ?? "");
      const url =
        `/LeaveAdj/SetLeaveAdj?p_empServiceNo=${q(serviceNo)}&p_leaveType=${q(leaveType)}` +
        `&p_adjustmentDate=${q(date)}&p_days=${q(days)}&p_adjustmentType=${q(adjustmentType)}` +
        `&p_reason=${q(reason)}&p_createdBy=${q(createdBy)}`;
      const response = await axios.post(url);
      console.log("[LeaveAdj] add response:", response.data);

      const body = response.data;
      if (body?.StatusCode !== undefined && body.StatusCode !== 200) {
        throw new Error(body?.Result || body?.Message || `Server error (status ${body.StatusCode})`);
      }
      return body;
    } catch (error) {
      console.error("[LeaveAdj] Error adding adjustment:", error);
      throw error;
    }
  },
};

export default LeaveAdjustmentService;